export class RefreshError extends Error {
    kind;
    statusCode;
    /**
     * `kind` defaults to `'http'` when a `statusCode` is provided, otherwise `'blocked'`.
     */
    constructor(message, options = {}) {
        super(message);
        this.name = 'RefreshError';
        this.kind = options.kind ?? (options.statusCode !== undefined ? 'http' : 'blocked');
        this.statusCode = options.statusCode;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
export function isUnauthenticatedRefreshError(error) {
    if (!(error instanceof RefreshError))
        return false;
    return error.kind === 'blocked' || error.statusCode === 400 || error.statusCode === 401 || error.statusCode === 403;
}
//# sourceMappingURL=refresh-error.js.map